import App from '@/app'
import '@/components'
import '@/modules'
import '@/views'

App.run()